<p-dialog
  [style]="{ width: '1009px' }"
  [visible]="displayModal"
  [modal]="true"
  [resizable]="false"
  (visibleChange)="onCancelPaymentMethod()"
  header="{{ 'ARC_PAYMENT_ADD_PAYMENT_METHOD' | translate }}"
>
  <div id="create-payment-accounts-info">
    <aur-notice
      *ngIf="showAutopaySuggestionBanner"
      severity="warning"
      id="banner-autopay-suggestion"
    >
      <div>
        {{ 'ARC_PAYMENT_AUTOPAY_SUGGESTION_BANNER_TEXT' | translate }}
      </div>
    </aur-notice>
    <aur-notice
      *ngIf="showSignInNotice"
      severity="info"
      id="add-payment-sign-in-notice"
      class="add-payment-sign-in-notice"
    >
      <div>
        {{ 'ARC_PAYMENT_ADD_PAYMENT_METHOD_SIGN_IN_NOTICE' | translate }}
      </div>
    </aur-notice>
    <aur-notice
      *ngIf="isScheduledPayment"
      severity="info"
      id="add-payment-dialog-notice"
      class="add-payment-dialog-notice"
    >
      <div>
        {{ 'ARC_PAYMENT_METHOD_SCHEDULED_PAYMENT_NOTICE' | translate }}
      </div>
    </aur-notice>
  </div>

  <payment-method-form
    #paymentMethodForm
    [paymentMethodForm]="addPaymentForm"
    [acceptAch]="acceptAch"
    [acceptCreditCard]="acceptCreditCard"
    [showPaymentToggleDefault]="showPaymentToggleDefault"
    [cardOverrideEligible]="cardOverrideEligible"
    [allowableCardBrands]="allowableCardBrands"
    [showSavePaymentAccount]="createSavedPaymentAccountEnabled"
    [useRemoteCardCaptureForm]="useQRCodeForRemoteCardCapture"
    [userCountry]="userCountry"
    (paymentMethodTypeToggled)="toggleChanged()"
    (cardOverrideSelected)="onCardOverrideClick()"
  >
  </payment-method-form>

  <p-footer id="add-payment-account-footer" class="pay-modal-footer">
    <button
      id="col-cancel-payment-method"
      class="review-payment-section"
      aur-button
      type="button"
      importance="secondary"
      (click)="onCancelPaymentMethod()"
    >
      {{ 'ARC_PAYMENT_CANCEL' | translate }}
    </button>

    <button
      id="col-use-payment-method"
      class="review-payment-section"
      importance="primary"
      (click)="onUpdatePaymentMethod()"
      aur-button
      type="submit"
    >
      {{
        isCanadianPadRequiredFlow &&
        addPaymentForm.controls.selectedPaymentMethod.value ===
          paymentMethodType.ACH
          ? ('ARC_PAYMENT_PROCEED_TO_CREATE_PAD' | translate)
          : ('ARC_PAYMENT_CONTINUE' | translate)
      }}
    </button>
  </p-footer>
</p-dialog>

<aur-confirmation
  #padSignedSeparatelyConfirmation
  id="add-payment-method-pad-signed-separately-confirmation-popup"
  message="{{ padSignedSeparatelyConfirmationText }}"
  [closable]="true"
  header="{{ 'ARC_PAYMENT_HEADER_PAD_AGREEMENT_DIALOG' | translate }}"
  acceptLabel="{{ 'ARC_PAYMENT_YES' | translate }}"
  rejectLabel=" {{ 'ARC_PAYMENT_NO' | translate }}"
  (accept)="onAcceptPadSignedSeparatelyConfirmation()"
  (reject)="onRejectPadSignedSeparatelyConfirmation()"
  (cancel)="onCancelPadSignedSeparatelyConfirmation()"
></aur-confirmation>

<aur-confirmation
  #savePaymentMethodConfirmation
  id="save-payment-method-confirmation-popup"
  message="{{
    'ARC_PAYMENT_SAVE_PAYMENT_METHOD_CONFIRMATION_TEXT' | translate
  }}"
  [closable]="true"
  header="{{
    'ARC_PAYMENT_SAVE_PAYMENT_METHOD_CONFIRMATION_HEADER' | translate
  }}"
  acceptLabel="{{ 'ARC_PAYMENT_SAVE' | translate }}"
  rejectLabel=" {{ 'ARC_PAYMENT_DO_NOT_SAVE' | translate }}"
  (accept)="onAcceptSavePaymentMethodConfirm()"
  (reject)="onRejectSavePaymentMethodConfirm()"
  (cancel)="onCancelSavePaymentMethodConfirm()"
></aur-confirmation>

<payment-add-pad-agreement
  *ngIf="displayAddPadAgreementDialog"
  [paymentMethod]="paymentMethod.value"
  [isSetInterval]="isSetIntervalPad"
  (cancelAddPadAgreement)="onCancelAddPadAgreement()"
  (submitAddPadAgreement)="onSubmitAddPadAgreement($event)"
></payment-add-pad-agreement>

@if (displayRemoteCardCaptureQRCode()){
<shared-remote-card-capture-qrcode
  [sessionId]="sessionId"
  [tenantId]="tenantId"
  [paymentAccountNumber]="accountNumber"
  [authToken]="authUserToken"
  [wSessionId]="walletSessionId()!"
  (close)="handleCloseQRCodeModal()"
></shared-remote-card-capture-qrcode>
}
